var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenVetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8335 1.3335C4.29374 1.3335 4.66684 1.70659 4.66684 2.16683V3.00017H5.50018C5.96042 3.00017 6.33351 3.37327 6.33351 3.8335C6.33351 4.29374 5.96042 4.66684 5.50018 4.66684H4.66684V5.50018C4.66684 5.96041 4.29374 6.33351 3.8335 6.33351C3.37327 6.33351 3.00017 5.96041 3.00017 5.50018V4.66684H2.16683C1.70659 4.66684 1.3335 4.29374 1.3335 3.8335C1.3335 3.37327 1.70659 3.00017 2.16683 3.00017H3.00017V2.16683C3.00017 1.70659 3.37327 1.3335 3.8335 1.3335ZM3.8335 9.66685C4.29374 9.66685 4.66684 10.04 4.66684 10.5002V11.3335H5.50018C5.96042 11.3335 6.33351 11.7066 6.33351 12.1669C6.33351 12.6271 5.96042 13.0002 5.50018 13.0002H4.66684V13.8335C4.66684 14.2938 4.29374 14.6669 3.8335 14.6669C3.37327 14.6669 3.00017 14.2938 3.00017 13.8335V13.0002H2.16683C1.70659 13.0002 1.3335 12.6271 1.3335 12.1669C1.3335 11.7066 1.70659 11.3335 2.16683 11.3335H3.00017V10.5002C3.00017 10.04 3.37327 9.66685 3.8335 9.66685Z",
    fill: "#89A037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66681 1.3335C10.0449 1.3335 10.3756 1.58807 10.4724 1.95359L11.4551 5.66595L14.2499 7.27836C14.5079 7.42719 14.6668 7.70237 14.6668 8.00018C14.6668 8.298 14.5079 8.57318 14.2499 8.72201L11.4551 10.3344L10.4724 14.0468C10.3756 14.4123 10.0449 14.6669 9.66681 14.6669C9.2887 14.6669 8.95798 14.4123 8.86122 14.0468L7.87854 10.3344L5.08374 8.722C4.82577 8.57318 4.66684 8.298 4.66684 8.00018C4.66684 7.70237 4.82577 7.42719 5.08374 7.27836L7.87854 5.66595L8.86122 1.95359C8.95798 1.58807 9.2887 1.3335 9.66681 1.3335Z",
    fill: "#89A037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVetting);
export default __webpack_public_path__ + "static/media/green-vetting.6a783e9298d9149bd9e8c0ffc8c12032.svg";
export { ForwardRef as ReactComponent };